import { CSSProperties, ReactNode } from "react";
import { IonItem } from "@ionic/react";
import { Colors, Icon, IconName } from "main";

import { ValuesOf } from "~utils";

import styles from "./DataItemView.module.css";

type ExtractedIonItemProps = Parameters<typeof IonItem>[0];

type DataItemViewProps = ExtractedIonItemProps & {
  icon?: IconName;
  iconColor?: ValuesOf<typeof Colors>;
  label: ReactNode | string;
  stackLayout?: boolean;
  style?: CSSProperties;
};

// Render `icon` (if provided), `label` and `children` in a few orientations.
//
//  0 - 899px (or when `stackLayout` is true)
//
//  +------+-------+----------+
//  | icon | label            |
//  |      | children         |
//  +------+-------+----------+
//
//  +------+-------+----------+
//  | label                   |
//  | children                |
//  +------+-------+----------+
//
//  900px and up
//
//  +------+-------+----------+
//  | icon | label | children |
//  +------+-------+----------+
//
//  +------+-------+----------+
//  | label        | children |
//  +------+-------+----------+
export function DataItemView(props: DataItemViewProps) {
  const { icon, iconColor, label, lines, stackLayout, children, style } = props;

  return (
    <IonItem
      lines={lines || "none"}
      className={`${styles["data-item"]} ion-no-padding`}
      style={{ ...style }}
    >
      <div
        className={`${icon ? styles["data-grid-icon"] : styles["data-grid-no-icon"]} ${
          stackLayout && icon
            ? styles["data-grid-icon-stacked"]
            : stackLayout && !icon
              ? styles["data-grid-no-icon-stacked"]
              : ""
        }`}
      >
        {icon && (
          <div className={`${styles.icon}`}>
            <Icon name={icon} color={iconColor} />
          </div>
        )}
        <div
          className={styles.label}
          style={{
            gridColumnStart: icon ? 2 : undefined,
            gridColumn: stackLayout ? "span 2" : undefined,
          }}
        >
          {label}
        </div>
        <div className={styles.children}>{children}</div>
      </div>
    </IonItem>
  );
}
